import { createApp } from 'vue'
import App from './App.vue'
import NutUI from "@nutui/nutui"
import "@nutui/nutui/dist/style.css"

import './assets/font/iconfont.css'
import './assets/css/index.css'
////微信官方Weui
// import WEUI from "weui"
// import 'weui'

import axios from 'axios'
import Router from "./router/index"  // 导入路由对象
//设置axios请求头加入token
axios.interceptors.request.use(function(config)
{
    //console.log(config.url)
    if (config.url === '/')
    {
        return config
    } 
    else 
    { 
        if (window.sessionStorage.getItem('AcceptToken')) { 
            //在请求头加入token，名字要和后端接收请求头的token名字一样 
            ///config.headers.token=window.localStorage.getItem('AcceptToken');
             config.headers.Authorization = window.sessionStorage.getItem("AcceptToken");
        } 
    } 
    return config; 
},
error => { 
     return Promise.reject(error)
});

///拦截返回报错信息
axios.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response.status === 400) {
        if(error.response.data.auth == 0) ////用户缓存失效后auth=0
        {
            window.location.href='/WxPay/Login'  ////用户失效后退回登录页面
        }
      }
      return Promise.reject(error)
    }
)


const app = createApp(App);


//2.配置请求根路径
//  axios.defaults.baseURL="/"

 // 不能设置为 true,不然发布到服务器返回值为空
//  axios.defaults.withCredentials = false;
//3.全局配置axios
app.config.globalProperties.$axios = axios


app.use(Router)
app.use(NutUI)
app.mount('#app')
